import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "lib-flexible";

// 部署新版检测
import updateChecker from "./utils/updateChecker";

const app = createApp(App);

// icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(store);
app.use(router);
app.use(ElementPlus);

// ========== 鸿蒙 / 部分 Android 浏览器：键盘弹起时强制 reflow ==========
// 现象：el-dialog 遮罩层在键盘弹起的瞬间未及时重绘，整个视口变黑屏
// 解决：监听 visualViewport resize，强制对 .el-overlay 做一次 reflow
if (typeof window !== 'undefined' && (window as any).visualViewport) {
  const vv = (window as any).visualViewport;
  let lastHeight = vv.height;
  const forceReflow = () => {
    document.querySelectorAll('.el-overlay').forEach((el) => {
      // 读 + 写 offsetHeight 触发同步 reflow
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      (el as HTMLElement).offsetHeight;
    });
    lastHeight = vv.height;
  };
  vv.addEventListener('resize', () => {
    if (Math.abs(vv.height - lastHeight) > 50) {
      // 视口高度变化超过 50px（键盘弹起/收起）
      forceReflow();
    }
  });
}

// 挂载后启动版本检测
app.mount("#app").$nextTick(() => {
  updateChecker.init();
});
